module.exports = __webpack_public_path__ + "static/img/core1.76026dd9.jpg";